import React from 'react';
import { Bank } from 'service/dto/bank.dto';
import BankImg from '../../../assets/assets/bank.png';
import { Icon, Icons } from 'components/Icon';

type Props = {
  bank: Bank;
  selectedAssetId?: number;
  handleShowDetails?: () => void;
};

export default function BankAsset({
  bank,
  selectedAssetId,
  handleShowDetails
}: Props) {
  return (
    <>
      <div className="border-b border-[#E5E5E5]">
        <div className="flex items-center justify-between p-3 px-5">
          <span className="text-base font-normal text-[#34475E]">
            Bank Account
          </span>
          {handleShowDetails && (
            <button
              type="button"
              className={`cursor-pointer ${
                selectedAssetId === bank.id ? 'rotate-180' : ''
              }`}
              onClick={handleShowDetails}
            >
              <Icon name={Icons.ArrowDownCircle} />
            </button>
          )}
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between px-4 pb-1">
        <div className="mr-3 space-y-2">
          <img src={BankImg} className="h-[6.5rem] w-[6.5rem] object-contain" />
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">Bank</div>
          <div className="text-xs text-slate-600 ">{bank.bankName}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Account Number
          </div>
          <div className="text-xs text-slate-600 ">{bank.accountNumber}</div>
        </div>
        {bank.totalBeneficiary ? (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">
              Number of Beneficaries
            </div>
            <div className="text-xs text-slate-600 ">
              {bank.totalBeneficiary}
            </div>
          </div>
        ) : (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">
              Account Type
            </div>
            <div className="text-xs text-slate-600 ">{bank.accountType}</div>
          </div>
        )}
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Percentage Alloted
          </div>
          <div className="text-xs text-slate-600 ">
            {bank.percentageAlloted}%
          </div>
        </div>
        <div className="my-2 mr-3 space-y-2"></div>
      </div>
    </>
  );
}
